import { schema } from 'normalizr';
import { SchemaKeys } from 'data/core';
import { dataNormalizer } from 'data/core/utils';
import { projectSchema } from 'data/projects/schema';
const taskSchema = new schema.Entity(SchemaKeys.Tasks, {}, {
    idAttribute: 'taskId'
});
taskSchema.define({
    subTasks: [
        taskSchema
    ],
    project: projectSchema
});
export { taskSchema };
export const taskNormalizer = (data)=>dataNormalizer(data, taskSchema);
